/*Global*/
import logo from '../assets/Logo/Logo.png';
import footerLogo from '../assets/Logo/Footer-Logo.png';


/*Home*/
import home1 from '../assets/Home/Home-1.jpg';


/*About*/
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';
import about3 from '../assets/About/About-3.jpg';
import about4 from '../assets/About/About-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog11 from '../assets/Blog/Blogs/Blog-11.jpg';
import blog11Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog11Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog11Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog11Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog11Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog12 from '../assets/Blog/Blogs/Blog-12.jpg';
import blog12Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog12Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog12Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog12Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog12Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog13 from '../assets/Blog/Blogs/Blog-13.jpg';
import blog13Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog13Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog13Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog13Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog13Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog14 from '../assets/Blog/Blogs/Blog-14.jpg';
import blog14Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog14Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog14Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog14Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog14Comment3 from '../assets/Blog/Comments/Pic-3.jpg';


/*Shop*/
import product1Gallery1 from '../assets/Templates/Landing-Pages/1/1.jpg';
import product1Gallery2 from '../assets/Templates/Landing-Pages/1/2.jpg';
import product1Gallery3 from '../assets/Templates/Landing-Pages/1/3.jpg';
import product1Gallery4 from '../assets/Templates/Landing-Pages/1/4.jpg';                   
import product1Gallery5 from '../assets/Templates/Landing-Pages/1/5.jpg';
import product1Gallery6 from '../assets/Templates/Landing-Pages/1/6.jpg';
import product1Gallery7 from '../assets/Templates/Landing-Pages/1/7.jpg';
import product1Gallery8 from '../assets/Templates/Landing-Pages/1/8.jpg';
import product1Gallery9 from '../assets/Templates/Landing-Pages/1/9.jpg';
import product1Gallery10 from '../assets/Templates/Landing-Pages/1/10.jpg';

import product2Gallery1 from '../assets/Templates/Landing-Pages/2/1.jpg';
import product2Gallery2 from '../assets/Templates/Landing-Pages/2/2.jpg';
import product2Gallery3 from '../assets/Templates/Landing-Pages/2/3.jpg';
import product2Gallery4 from '../assets/Templates/Landing-Pages/2/4.jpg';                   
import product2Gallery5 from '../assets/Templates/Landing-Pages/2/5.jpg';
import product2Gallery6 from '../assets/Templates/Landing-Pages/2/6.jpg';
import product2Gallery7 from '../assets/Templates/Landing-Pages/2/7.jpg';
import product2Gallery8 from '../assets/Templates/Landing-Pages/2/8.jpg';
import product2Gallery9 from '../assets/Templates/Landing-Pages/2/9.jpg';
import product2Gallery10 from '../assets/Templates/Landing-Pages/2/10.jpg';

import product3Gallery1 from '../assets/Templates/Landing-Pages/3/1.jpg';
import product3Gallery2 from '../assets/Templates/Landing-Pages/3/2.jpg';
import product3Gallery3 from '../assets/Templates/Landing-Pages/3/3.jpg';
import product3Gallery4 from '../assets/Templates/Landing-Pages/3/4.jpg';                   
import product3Gallery5 from '../assets/Templates/Landing-Pages/3/5.jpg';
import product3Gallery6 from '../assets/Templates/Landing-Pages/3/6.jpg';
import product3Gallery7 from '../assets/Templates/Landing-Pages/3/7.jpg';
import product3Gallery8 from '../assets/Templates/Landing-Pages/3/8.jpg';
import product3Gallery9 from '../assets/Templates/Landing-Pages/3/9.jpg';
import product3Gallery10 from '../assets/Templates/Landing-Pages/3/10.jpg';

import product4Gallery1 from '../assets/Templates/Landing-Pages/4/1.jpg';
import product4Gallery2 from '../assets/Templates/Landing-Pages/4/2.jpg';
import product4Gallery3 from '../assets/Templates/Landing-Pages/4/3.jpg';
import product4Gallery4 from '../assets/Templates/Landing-Pages/4/4.jpg';                   
import product4Gallery5 from '../assets/Templates/Landing-Pages/4/5.jpg';
import product4Gallery6 from '../assets/Templates/Landing-Pages/4/6.jpg';
import product4Gallery7 from '../assets/Templates/Landing-Pages/4/7.jpg';
import product4Gallery8 from '../assets/Templates/Landing-Pages/4/8.jpg';
import product4Gallery9 from '../assets/Templates/Landing-Pages/4/9.jpg';
import product4Gallery10 from '../assets/Templates/Landing-Pages/4/10.jpg';

import product5Gallery1 from '../assets/Templates/Landing-Pages/5/1.jpg';
import product5Gallery2 from '../assets/Templates/Landing-Pages/5/2.jpg';
import product5Gallery3 from '../assets/Templates/Landing-Pages/5/3.jpg';
import product5Gallery4 from '../assets/Templates/Landing-Pages/5/4.jpg';                   
import product5Gallery5 from '../assets/Templates/Landing-Pages/5/5.jpg';
import product5Gallery6 from '../assets/Templates/Landing-Pages/5/6.jpg';
import product5Gallery7 from '../assets/Templates/Landing-Pages/5/7.jpg';
import product5Gallery8 from '../assets/Templates/Landing-Pages/5/8.jpg';
import product5Gallery9 from '../assets/Templates/Landing-Pages/5/9.jpg';
import product5Gallery10 from '../assets/Templates/Landing-Pages/5/10.jpg';

import product6Gallery1 from '../assets/Templates/Landing-Pages/6/1.jpg';
import product6Gallery2 from '../assets/Templates/Landing-Pages/6/2.jpg';
import product6Gallery3 from '../assets/Templates/Landing-Pages/6/3.jpg';
import product6Gallery4 from '../assets/Templates/Landing-Pages/6/4.jpg';                   
import product6Gallery5 from '../assets/Templates/Landing-Pages/6/5.jpg';
import product6Gallery6 from '../assets/Templates/Landing-Pages/6/6.jpg';
import product6Gallery7 from '../assets/Templates/Landing-Pages/6/7.jpg';
import product6Gallery8 from '../assets/Templates/Landing-Pages/6/8.jpg';
import product6Gallery9 from '../assets/Templates/Landing-Pages/6/9.jpg';
import product6Gallery10 from '../assets/Templates/Landing-Pages/6/10.jpg';

import product7Gallery1 from '../assets/Templates/Landing-Pages/7/1.jpg';
import product7Gallery2 from '../assets/Templates/Landing-Pages/7/2.jpg';
import product7Gallery3 from '../assets/Templates/Landing-Pages/7/3.jpg';
import product7Gallery4 from '../assets/Templates/Landing-Pages/7/4.jpg';                   
import product7Gallery5 from '../assets/Templates/Landing-Pages/7/5.jpg';
import product7Gallery6 from '../assets/Templates/Landing-Pages/7/6.jpg';
import product7Gallery7 from '../assets/Templates/Landing-Pages/7/7.jpg';
import product7Gallery8 from '../assets/Templates/Landing-Pages/7/8.jpg';
import product7Gallery9 from '../assets/Templates/Landing-Pages/7/9.jpg';
import product7Gallery10 from '../assets/Templates/Landing-Pages/7/10.jpg';

import product8Gallery1 from '../assets/Templates/Landing-Pages/8/1.jpg';
import product8Gallery2 from '../assets/Templates/Landing-Pages/8/2.jpg';
import product8Gallery3 from '../assets/Templates/Landing-Pages/8/3.jpg';
import product8Gallery4 from '../assets/Templates/Landing-Pages/8/4.jpg';                   
import product8Gallery5 from '../assets/Templates/Landing-Pages/8/5.jpg';
import product8Gallery6 from '../assets/Templates/Landing-Pages/8/6.jpg';
import product8Gallery7 from '../assets/Templates/Landing-Pages/8/7.jpg';
import product8Gallery8 from '../assets/Templates/Landing-Pages/8/8.jpg';
import product8Gallery9 from '../assets/Templates/Landing-Pages/8/9.jpg';
import product8Gallery10 from '../assets/Templates/Landing-Pages/8/10.jpg';

import product9Gallery1 from '../assets/Templates/Landing-Pages/9/1.jpg';
import product9Gallery2 from '../assets/Templates/Landing-Pages/9/2.jpg';
import product9Gallery3 from '../assets/Templates/Landing-Pages/9/3.jpg';
import product9Gallery4 from '../assets/Templates/Landing-Pages/9/4.jpg';                   
import product9Gallery5 from '../assets/Templates/Landing-Pages/9/5.jpg';
import product9Gallery6 from '../assets/Templates/Landing-Pages/9/6.jpg';
import product9Gallery7 from '../assets/Templates/Landing-Pages/9/7.jpg';
import product9Gallery8 from '../assets/Templates/Landing-Pages/9/8.jpg';
import product9Gallery9 from '../assets/Templates/Landing-Pages/9/9.jpg';
import product9Gallery10 from '../assets/Templates/Landing-Pages/9/10.jpg';

import product10Gallery1 from '../assets/Templates/Landing-Pages/10/1.jpg';
import product10Gallery2 from '../assets/Templates/Landing-Pages/10/2.jpg';
import product10Gallery3 from '../assets/Templates/Landing-Pages/10/3.jpg';
import product10Gallery4 from '../assets/Templates/Landing-Pages/10/4.jpg';                   
import product10Gallery5 from '../assets/Templates/Landing-Pages/10/5.jpg';
import product10Gallery6 from '../assets/Templates/Landing-Pages/10/6.jpg';
import product10Gallery7 from '../assets/Templates/Landing-Pages/10/7.jpg';
import product10Gallery8 from '../assets/Templates/Landing-Pages/10/8.jpg';
import product10Gallery9 from '../assets/Templates/Landing-Pages/10/9.jpg';
import product10Gallery10 from '../assets/Templates/Landing-Pages/10/10.jpg';


const images = {

    /*Global*/
    logo,
    footerLogo,

    /*Home*/
    home1,

    /*About*/
    about1,
    about2,
    about3,
    about4,

    /*FAQs*/ 
    FAQs,


    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    blog11,
    blog11Gallery1,
    blog11Gallery2,
    blog11Comment1,
    blog11Comment2,
    blog11Comment3,

    blog12,
    blog12Gallery1,
    blog12Gallery2,
    blog12Comment1,
    blog12Comment2,
    blog12Comment3,

    blog13,
    blog13Gallery1,
    blog13Gallery2,
    blog13Comment1,
    blog13Comment2,
    blog13Comment3,

    blog14,
    blog14Gallery1,
    blog14Gallery2,
    blog14Comment1,
    blog14Comment2,
    blog14Comment3,


    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Gallery5,
    product1Gallery6,
    product1Gallery7,
    product1Gallery8,
    product1Gallery9,
    product1Gallery10,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3, 
    product2Gallery4,
    product2Gallery5,
    product2Gallery6,
    product2Gallery7,
    product2Gallery8,
    product2Gallery9,
    product2Gallery10,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3, 
    product3Gallery4,
    product3Gallery5,
    product3Gallery6,
    product3Gallery7,
    product3Gallery8,
    product3Gallery9,
    product3Gallery10,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3, 
    product4Gallery4,
    product4Gallery5,
    product4Gallery6,
    product4Gallery7,
    product4Gallery8,
    product4Gallery9,
    product4Gallery10,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3, 
    product5Gallery4,
    product5Gallery5,
    product5Gallery6,
    product5Gallery7,
    product5Gallery8,
    product5Gallery9,
    product5Gallery10,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3, 
    product6Gallery4,
    product6Gallery5,
    product6Gallery6,
    product6Gallery7,
    product6Gallery8,
    product6Gallery9,
    product6Gallery10,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3, 
    product7Gallery4,
    product7Gallery5,
    product7Gallery6,
    product7Gallery7,
    product7Gallery8,
    product7Gallery9,
    product7Gallery10,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3, 
    product8Gallery4,
    product8Gallery5,
    product8Gallery6,
    product8Gallery7,
    product8Gallery8,
    product8Gallery9,
    product8Gallery10,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3, 
    product9Gallery4,
    product9Gallery5,
    product9Gallery6,
    product9Gallery7,
    product9Gallery8,
    product9Gallery9,
    product9Gallery10,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3, 
    product10Gallery4,
    product10Gallery5,
    product10Gallery6,
    product10Gallery7,
    product10Gallery8,
    product10Gallery9,
    product10Gallery10,

};

export default images;